import { FunctionComponent } from "react";
import { css, Global, useTheme } from "@emotion/react";
import { StyledComponentOverrides } from "./styled-component-overrides.style";
import { ZIndex } from "src/ui/constants";

export const GlobalStyle: FunctionComponent = () => {
	const theme = useTheme();
	return (
		<Global
			styles={css`
				html body {
					overflow: hidden;
					overscroll-behavior: contain;
					background-color: #d5d8d7;
					font-family: ${theme.typography.fontFamily.primary};

					h1,
					h2,
					h3,
					h4,
					h5,
					h6 {
						font-family: ${theme.typography.fontFamily.primary};
					}
				}

				#app-root {
					height: 100%;
					width: 100%;
				}

				div[draggable="true"] > * {
					cursor: grab;
				}

				div[draggable="true"]:active > * {
					cursor: grabbing;
				}

				#dragging-element {
					position: absolute;
					opacity: 0.75;
					z-index: ${ZIndex.DragingElement};
					top: 0;
					left: 0;
					height: 100px;
					aspect-ratio: 1;
					background-size: contain;
					background-position: center;
					background-repeat: no-repeat;
					transition: opacity 0.3s;
					pointer-events: none;
					user-select: none;
					touch-action: none;

					&[draggable="true"] {
						height: auto;
						aspect-ratio: auto;
						box-shadow:
							0 4px 8px 0 rgba(0, 0, 0, 0.2),
							0 6px 20px 0 rgba(0, 0, 0, 0.2);
					}
				}

				${StyledComponentOverrides()}
			`}
		/>
	);
};
